import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {BehaviorSubject, Subject} from 'rxjs';

@Component({
  selector: 'arm-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit , OnDestroy{
  @Input() summaryTitle: string = null;
  @Input() menuTitle: string = null;
  @ViewChild('summary') summary: ElementRef;


  constructor(private loaderService: LoaderService) { }
  isMainContainerLoading: BehaviorSubject<boolean> = this.loaderService.isMainContainerLoading;

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.loaderService.hideSidePanel();
    this.loaderService.hideMainContainer();
  }
}
